import * as customerFormConstants from './customerFormConstants';

import CustomerForm from './CustomerForm';


export {
    CustomerForm,
    customerFormConstants
};


export default CustomerForm;
